import { render, staticRenderFns } from "./CoozzySidebarNavDropdown.vue?vue&type=template&id=035338da&scoped=true"
import script from "./CoozzySidebarNavDropdown.vue?vue&type=script&lang=js"
export * from "./CoozzySidebarNavDropdown.vue?vue&type=script&lang=js"
import style0 from "./CoozzySidebarNavDropdown.vue?vue&type=style&index=0&id=035338da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035338da",
  null
  
)

export default component.exports